import { RouteReport, periodToParams, toSource } from '../models';
import { backendCyclingProfiles } from './cycling-profile';
import { HttpService } from './http';
export class RouteReportService {
  static async getRouteReports({
    cyclabilityZoneId,
    period
  }) {
    try {
      const params = [];
      if (period) params.push(...periodToParams(period));
      if (cyclabilityZoneId) params.push({
        key: 'cyclability_zone_id',
        value: cyclabilityZoneId
      });
      const data = await HttpService.get('v2', '/route_reports', params);
      const routeReports = data.map(parseRouteReport);
      return routeReports;
    } catch (err) {
      console.error('[RouteReportService][getReports]', err);
      return [];
    }
  }
  static async getRouteReport(id) {
    try {
      const data = await HttpService.get('v2', `/route_reports/${id}`);
      const routeReports = parseRouteReport(data);
      return routeReports;
    } catch (err) {
      console.error('[ReportService][getReport]', err);
      throw err;
    }
  }
  static async send(props) {
    try {
      const data = await HttpService.post('v2', `/route_reports`, [], [], JSON.stringify(props));
      return parseRouteReport(data);
    } catch (err) {
      console.error('[RouteReportService][send]', err);
      throw err;
    }
  }
  static async updateRouteReport(id, props) {
    try {
      const data = await HttpService.put('v2', `/route_reports/${id}`, [], [], JSON.stringify(props));
      return parseRouteReport(data);
    } catch (err) {
      console.error('[RouteReportService][updateRouteReport]', err);
      throw err;
    }
  }
}
function parseRouteReport({
  id,
  created,
  creator,
  computed_route_id,
  profile,
  alternative,
  geo_steps,
  geo_itinerary,
  geo_report_itinerary,
  description,
  status,
  response,
  source
}) {
  return new RouteReport(id, new Date(created), creator, computed_route_id, backendCyclingProfiles[profile], alternative, geo_steps ? geo_steps.coordinates.map(coordinates => {
    return {
      type: 'Point',
      coordinates: coordinates
    };
  }) : undefined, geo_itinerary, geo_report_itinerary, description, status, response, toSource(source));
}